import { get } from './api';

export const productAPI = {
  getProducts() {
    return get('product');
  },

  getBasketProducts() {
    return get('menu-ingredients');
  },
};
